import { useQuery } from '@tanstack/react-query';

import { CampaignReadiness, getCampaignReadiness } from '../api/ach/readiness';
import { useConfig } from './useConfig';

// Fetches a campaign's (== AdGroup's) publish-readiness from the Tier-A ACH endpoint
// (ACH-gvkz), keyed by host + id. ACH is a supplementary, read-only signal and is NOT
// the session authority — so on ANY failure (including a 401; achGetJSON never logs
// out) this degrades to `undefined`, and the readiness panel simply renders nothing
// rather than erroring or breaking the AdGroup page.
function useCampaignReadiness(campaignId?: number) {
  const { achApiHost } = useConfig();

  return useQuery<CampaignReadiness | undefined>({
    queryKey: ['campaignReadiness', achApiHost, campaignId],
    queryFn: async () => {
      try {
        return await getCampaignReadiness(achApiHost, campaignId as number);
      } catch (err) {
        if (import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.warn('useCampaignReadiness: ACH fetch failed; hiding readiness panel', err);
        }
        return undefined;
      }
    },
    retry: false,
    enabled: !!campaignId,
  });
}

export default useCampaignReadiness;
